import React from 'react';
import styles from './Footer.module.css';
import logo_footer from '../../images/logo_footer.svg'
import icon_facebook from '../../images/IconFacebook.png'
import icon_whatsapp from '../../images/IconWhatsapp.svg'
import icon_instagram from '../../images/IconInstagram.svg'
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavItemClick = (index, item) => {
    if (item.path) {
      navigate(item.path);
      window.scrollTo(0, 0);
    }
  };

  const socialLinks = [
    { name: 'Facebook', icon: icon_facebook, url: 'https://www.facebook.com/scms.previdencia/' },
    { name: 'Instagram', icon: icon_instagram, url: 'https://www.instagram.com/scms.previdencia/' },
    { name: 'Whatsapp', icon: icon_whatsapp, url: 'https://wa.me/+5505492253483' }
  ];

  const navItems = [
    { title: "Home", path: "/", isActive: true },
    { title: "História", path: "/historia", isActive: false },
    { title: "Sustentabilidade", path: "/sustentabilidade", isActive: false },
    { title: "Galeria", path: "/galeria", isActive: false },
    { title: "Contato", path: "/contato", isActive: false }
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.mainInfo}>
          <img src={logo_footer} alt="SCMS Logo" className={styles.logo} />
        </div>

          <div className={styles.contactInfo}>
            <h3 className={styles.sectionTitle}>Contatos</h3>
            <address className={styles.address}>
              Telefone: (54) 3221-2777<br />
              E-mail: scms@scmsprevidencia.com.br<br />
              Endereço: Rua Garibaldi, 803<br />
              Centro - Caxias do Sul - RS CEP 95020-375
            </address>
          </div>

        <div className={styles.contactInfo}>
          <h3 className={styles.sectionTitle}>Atendimento a Deficientes<br />Auditivos ou de Fala</h3>
          <address className={styles.address}>
            Telefone: 0800 200 0819<br />
            E-mail: sac.especial.auditivo.fala@sinapp.org.br<br />
          </address><br />
          <h3 className={styles.sectionTitle}>Ouvidoria</h3>
          <address className={styles.address}>
            Telefone: 0800 703 1989<br />
            E-mail: ouvidoria@sinapp.org.br<br />
          </address>
        </div>

        <nav className={styles.pageLinks}>
          <h3 className={styles.sectionTitle}>Mapa do Site</h3>
          <ul>
            {navItems.map((item, index) => (
              <li key={index}>
                <span 
                  onClick={() => handleNavItemClick(index, item)}
                  className={styles.linkItem}
                >
                  {item.title}
                </span>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.socialLinks}>
          <h3 className={styles.sectionTitle}>Nossas redes sociais</h3>
          <ul>
            {socialLinks.map((link, index) => (
              <li key={index}>
                <a href={link.url} className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                  <img src={link.icon} alt={`${link.name} icon`} className={styles.socialIcon} />
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={styles.copyright}>
        © 2024 Todos os direitos reservados | Sociedade Caxiense de Mútuo Socorro
      </div>
    </footer>
  );
};

export default Footer;
